var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',[_c('div',{staticClass:"pb-8"},[_c('About'),_c('Directors'),_c('Specialties'),_c('Structure'),_c('HospitalizationGuide'),_c('Recycle')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }